import { useTranslation } from 'react-i18next';

import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import { useStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/hooks/useStatusBoard';

import Select from '../../../../components/Select';

type SoilTypeFieldProps = {
  isGerman?: boolean;
  titleHidden?: boolean;
  defaultSoilIndex?: number;
};

const SoilTypeField = ({ isGerman = false, titleHidden = false, defaultSoilIndex }: SoilTypeFieldProps) => {
  const { t } = useTranslation();

  const {
    soilSelect,
    soilType,
    setSoilType,
  } = isGerman 
    ? useGermanStatusBoard() 
    : useStatusBoard({ defaultSoilIndex });

  return (
    <Select
      options={soilSelect}
      onChange={(value) => setSoilType(value.value)}
      title={titleHidden ? '' : t('soilType')}
      placeholder={t('selectValue')}
      isBlueBg
      value={
        soilType?.length > 0
          ? [
            {
              value: soilType,
              label: soilType,
            },
          ]
          : []
      }
    />
  );
};

export default SoilTypeField;
